import { createAsyncThunk } from '@reduxjs/toolkit';
import { signOut } from 'firebase/auth';
import { auth } from '../../../firebaseConfig';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { getErrorMessage } from './utils.js';

// Logout user
export const logoutUser = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      // Clear Firebase auth state
      await signOut(auth);

      // Additional cleanup - clear any remaining Firebase auth state
      if (auth.currentUser) {
        console.warn('Firebase auth state not fully cleared, forcing cleanup');
      }

      showSuccessToast('Logged out successfully');
      return null;
    } catch (error) {
      console.error('Logout error:', error);
      const errorMessage = getErrorMessage(error);
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);
